export const iconFontAwesomeBuildingsTentArrowsDown = (
	<i className="fa-solid fa-tent-arrows-down"></i>
);
